import React from "react";

export function DeviceTechnicalTelemetryOverviewItemContainer({children, title}) {
    return <div className="device-parameters-contentbox-item p-1">
        <p className="ms-0 mb-0" style={{fontWeight: '600', fontSize: '18px'}}>{title}</p>
        <hr style={{margin: 0}}/>
        {children}
    </div>
}